import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import * as api from '../api/endpoints';

const hm = (iso) => new Date(iso).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
const dur = (ms) => { const m = Math.max(0, Math.floor(ms / 60000)); return `${Math.floor(m / 60)}h ${String(m % 60).padStart(2, '0')}m`; };

/**
 * Working-day clock. Opening the helpdesk for the first time each day starts it (recorded
 * server-side with the IP); submitting the daily report finishes it.
 */
const WorkdayChip = () => {
  const { employee } = useAuth();
  const [w, setW] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!employee) return undefined;
    const load = () => api.workdayStart().then(setW).catch(() => {});
    load();
    window.addEventListener('helpdesk-workday-refresh', load);
    const tick = setInterval(() => setNow(Date.now()), 30000);
    // heartbeat only while the person is actually using the app (not for an idle open tab)
    const ping = setInterval(() => {
      const last = Number(localStorage.getItem('helpdesk_last_activity') || 0);
      if (Date.now() - last < 5 * 60000) api.workdayPing().catch(() => {});
    }, 5 * 60000);
    return () => { window.removeEventListener('helpdesk-workday-refresh', load); clearInterval(tick); clearInterval(ping); };
  }, [employee?.mavis_user_id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!w) return null;
  const start = new Date(w.started_at).getTime();
  const end = w.finished_at ? new Date(w.finished_at).getTime() : now;
  const title = `Started ${hm(w.started_at)} from ${w.start_ip || 'unknown IP'}${w.start_outside_office ? ' (outside office)' : ''}`
    + (w.finished_at ? `\nFinished ${hm(w.finished_at)} from ${w.finish_ip || 'unknown IP'}${w.finish_outside_office ? ' (outside office)' : ''}` : '\nFinishes when you submit your daily report');
  return (
    <span className="label-chip" title={title} style={{ alignSelf: 'center', whiteSpace: 'nowrap' }}>
      {w.finished_at ? `✓ ${hm(w.started_at)}–${hm(w.finished_at)} · ${dur(end - start)}` : `⏱ since ${hm(w.started_at)} · ${dur(end - start)}`}
      {w.start_outside_office && <span style={{ marginLeft: 6, color: '#ffcf7a', fontWeight: 700 }}>OUTSIDE OFFICE</span>}
    </span>
  );
};

export default WorkdayChip;
